import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExampleRoutingModule } from './example-routing.module';
import { ExampleComponent } from './pages/example/example.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExampleSearchComponent } from './pages/example-search/example-search.component';
import { ExampleSingleComponent } from './pages/example-single/example-single.component';
import { ExampleFormComponent } from './pages/example-form/example-form.component';
import { ExampleDoubleComponent } from './pages/example-double/example-double.component';
import { ExampleDoubleDetailComponent } from './pages/example-double/example-double-detail/example-double-detail.component';
import { ExampleInlineEditComponent } from './pages/example-inline-edit/example-inline-edit.component';
import { ExampleUploadComponent } from './pages/example-upload/example-upload.component';
import { ExampleSearchInlineEditComponent } from './pages/example-search-inline-edit/example-search-inline-edit.component';
import { IbpaasBaseComponentModule } from '../ibpaas-base-component.module';


@NgModule({
  declarations: [
    ExampleComponent,
    ExampleSearchComponent,
    ExampleSingleComponent,
    ExampleFormComponent,
    ExampleDoubleComponent,
    ExampleDoubleDetailComponent,
    ExampleInlineEditComponent,
    ExampleUploadComponent,
    ExampleSearchInlineEditComponent
  ],
  imports: [
    CommonModule,
    ExampleRoutingModule,
    IbpaasBaseComponentModule,
    SharedModule
  ]
})
export class ExampleModule { }
